<template>
  <button
    class="ToggleSidebarControl"
    :class="{
      'ToggleSidebarControl--active': isToggled,
      'ToggleSidebarControl--highlighted': isHiglighted,
    }"
    @click="isToggled = !isToggled"
  >
    <Icon
      icon="material-symbols-light:chevron-left-rounded"
      class="maplibregl-ctrl-icon text-white h-10 w-10"
      :class="{ 'ToggleSidebarControl__icon--inversed': inversedDirection }"
    />
  </button>
</template>

<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { computed } from 'vue'
const isToggled = defineModel<boolean>({ default: false })
const props = withDefaults(
  defineProps<{
    inversedDirection?: boolean
    isHiglightedWhenOff?: boolean
  }>(),
  {
    inversedDirection: false,
    isHiglightedWhenOff: false,
  },
)
const isHiglighted = computed(() => !isToggled.value && props.isHiglightedWhenOff)
</script>

<style lang="scss">
.ToggleSidebarControl {
  pointer-events: all;
  background-color: var(--color-main);
  &:hover {
    background-color: var(--color-main-hover);
  }
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: var(--dim-radius);
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  &--highlighted {
    background-color: var(--color-main-hover);
  }

  &--active {
    .maplibregl-ctrl-icon {
      rotate: 180deg;
    }
  }

  .maplibregl-ctrl-icon {
    transition: all 0.3s ease-in-out;
  }

  &__icon--inversed {
    transform: scaleX(-1);
  }
}
</style>
